import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import HeaderAction from "../../components/HeaderAction/HeaderAction";
import axios from "axios";
import './PaymentResultPage.css';
import {Loading} from "../../components/Loading/Loading"; // Подключаем CSS стили
import {useTranslation} from "react-i18next";

const PaymentResultPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const orderId = params.get("order_id");
    const itemTitle = params.get("itemTitle");
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`https://api.mafia.top/api/payment-result/${orderId}`);
                console.log(res.data.status);
                if (res.data.status === 'success') {
                    const classItem = orderId.split('_')[0];
                    const itemStyle = orderId.split('_')[2];
                    if (classItem === 'buyAmulet') {
                        const probability = orderId.split('_')[3];
                        navigate(`/carousel?cardRole=${itemStyle}&probability=${probability}`);
                    } else if (classItem === 'buyItem') {
                        navigate(`/getMessage?itemTitle=${itemTitle}&itemStyle=${itemStyle}`);
                    }

                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);


    return (
        <div className="background">
            <div className="container">
                <div className="page-container">
                    {isLoading && (
                        <>
                            <svg className="svg-loader" viewBox="0 0 50 50">
                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                            </svg>
                            <div className="page-text">{t('paymentWaitingText')}</div>

                            <div className="cancel-button" onClick={() => navigate('/')}>{t('cancel')}</div>
                        </>
                    )}

                </div>
            </div>
        </div>
    );
};

export default PaymentResultPage;
